import React, { useEffect } from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import _ from "lodash";
import styled from "@emotion/styled";
import parse from "html-react-parser";
import moment from "moment";
import { faCalendar } from "@fortawesome/pro-light-svg-icons";
import { useLocation } from "@reach/router";
import ArrowButton from "./ArrowButton";
import Container from "./Container";
// import default_image from "../images/headers/home.png";
import default_image from "../images/headers/distributors.png";
import CarouselImages from "./CarouselImages";
import CustomizedIcon from "./CustomizedIcon";
import Modal from "./Modal";

function Hero({
  title,
  description,
  buttonText,
  kind,
  items,
  videoPath,
  startDate,
  time,
  filterColor,
  buttonPath = "/",
  homePage = false,
  backgroundImage = default_image,
  height = 650,
}) {
  const [isLoadedVideo, setIsLoadedVideo] = React.useState(!videoPath);
  const [showContentModal, setShowContentModal] = React.useState(false);
  const { pathname } = useLocation();
  const formatDate = (date, format = "HH:mm") => moment(date).format(format);

  useEffect(() => {
    if (videoPath) {
      document.getElementById("vid")?.play();
      setIsLoadedVideo(true);
    }
  }, []);

  const renderContent = (_title, _description, _buttonPath, _buttonText, modalButtonText, modalContent, secondButtonPath, secondButtonText) => {
    const currentTitle = title || _title;
    const currentDescription = description || _description;
    const currentButtonPath = _buttonPath || buttonPath;
    const currentButtonText = buttonText || _buttonText;
    const isEvent = pathname.includes("event");
    return (
      <Box sx={{ position: "absolute", width: "100%", bottom: 0 }} pb={isEvent ? 12 : 16}>
        <Container>
          <Box textAlign="start" maxWidth={(theme) => theme.spacing(62)}>
            {kind && (
              <Chip
                sx={{ marginBottom: (theme) => theme.spacing(1) }}
                label={kind}
                color={pathname?.includes("event") ? "secondary" : "blur"}
                variant="filled"
              />
            )}
            {currentTitle && (
              <Box mb={1.5}>
                {homePage ? (
                  <Typography
                    component="h2" // h1 but serp get like title this h1
                    variant="h1"
                    color="inherit.main"
                    lineHeight="84px"
                    fontSize="48px"
                  >
                    {currentTitle}
                  </Typography>
                ) : (
                  <Typography
                    variant="h2"
                    color="inherit.main"
                    lineHeight="54px"
                  >
                    {currentTitle}
                  </Typography>
                )}
              </Box>
            )}
            {currentDescription && (
              <Box>
                <Typography color="white" variant="text" lineHeight="28px">
                  {typeof currentDescription === "object"
                    ? currentDescription
                    : parse(currentDescription)}
                </Typography>
              </Box>
            )}
            {startDate && time && (
              <Box my={2} display="flex" alignItems="center">
                <CustomizedIcon
                  icon={faCalendar}
                  color="#FFFFFF"
                  size={20}
                  padding={1.5}
                />
                <Box ml={2}>
                  <Box>
                    <Typography color="white" variant="text">
                      {formatDate(startDate, "dddd, DD MMMM YYYY")}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography color="white" variant="text">
                      {time}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}
            <Stack direction="row" spacing={1} mt={3} alignItems="center">
              {currentButtonText && (
                <ArrowButton
                  path={currentButtonPath}
                  title={currentButtonText}
                />
              )}
              {secondButtonText && secondButtonPath && (
                <ArrowButton path={secondButtonPath} title={secondButtonText} />
              )}
              {modalButtonText &&
                modalContent &&
                parse(`${modalContent}`, {
                  htmlparser2: {
                    xmlMode: true,
                  },
                }).length > 0 && (
                  <ArrowButton
                    title={modalButtonText}
                    onClick={() => setShowContentModal(modalContent)}
                  />
                )}
            </Stack>
          </Box>
        </Container>
      </Box>
    );
  };

  return (
    <Box>
      {!_.isNull(items) && !_.isEmpty(items) ? (
        <CarouselImages
          items={items}
          renderContent={(title, description, buttonPath, buttonText, modalButtonText, modalContent, secondButtonPath, secondButtonText) => renderContent(title, description, buttonPath, buttonText, modalButtonText, modalContent, secondButtonPath, secondButtonText)}
        />
      ) : (
        <StyledBox homePage={homePage} height={height}>
          <Box
            className="background-image"
            sx={{
              backgroundImage:
                videoPath && isLoadedVideo
                  ? "linear-gradient(90deg, rgba(27,54,93,1) 0%, rgba(126,5,5,0) 100%)"
                  : `linear-gradient(90deg, ${
                      filterColor || "rgba(27,54,93,1)"
                    } 0%, rgba(126,5,5,0) 100%), url(${backgroundImage})`,
            }}
          >
            {renderContent()}
            {videoPath && (
              <video id="vid" autoPlay muted loop>
                <source src={videoPath} type="video/mp4" />
              </video>
            )}
          </Box>
        </StyledBox>
      )}
      {showContentModal && (
        <Modal
          open
          onClose={() => setShowContentModal(false)}
          backgroundColor="white"
        >
          <Typography>{parse(showContentModal)}</Typography>
        </Modal>
      )}
    </Box>
  );
}

const StyledBox = styled(Box)(
  ({ homePage, height }) => `
  min-height: ${homePage ? "740px" : `${height}px`};
  position: relative;
  .background-image {
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    #vid{
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      z-index: -1;
    }
  }
`,
);

export default Hero;
